var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../../../../lib/utils/consts";
import * as styles from "./index.module.css";
import ExprInput from "../../../../../../lib/comps/ExprInput";
import CSSEditor from "../../../../../../lib/comps/CSSEditor";
import { tryEval } from "../../../../../../lib/utils";
let ConditionStyleList = class ConditionStyleList extends Vue {
  constructor() {
    super(...arguments);
    this.showCondStyle = false;
  }
  get stylePanelState() {
    return this.designer.stylePanelState;
  }
  get renderer() {
    return this.designer.renderer;
  }
  toggleShowCondStyle() {
    this.showCondStyle = !this.showCondStyle;
  }
  getConditionItem(conditionStyle, index) {
    const h = this.$createElement;
    const {
      stylePanelState
    } = this;
    const {
      setConditionStyleBySelector,
      getStyleMail,
      deleteConditionStyle
    } = stylePanelState;
    const actived = tryEval(conditionStyle.cond, this.renderer);
    return h("div", {
      "class": [styles.condStyleItem, actived && styles.activedcondStyleItem]
    }, [h("div", {
      "class": styles.flexTitle
    }, [h("div", {
      "style": "flex: 1;"
    }, [h(ExprInput, {
      "class": this.readonly ? styles.readOnlyEditor : '',
      "style": 'height:auto',
      "attrs": {
        "value": conditionStyle.cond,
        "placeholder": '添加条件:',
        "readonly": this.readonly,
        "multipleLine": false,
        "notifyVoidReturn": true
      },
      "on": {
        "change": v => setConditionStyleBySelector(index, v, null)
      }
    })]), h("a-icon", {
      "attrs": {
        "type": "minus"
      },
      "class": styles.conditionStyleButton,
      "on": {
        "click": () => {
          !this.readonly && deleteConditionStyle(index);
        }
      }
    })]), this.readonly || h(CSSEditor, {
      "attrs": {
        "readonly": this.readonly,
        "value": conditionStyle.style
      },
      "on": {
        "change": v => setConditionStyleBySelector(index, null, getStyleMail(v))
      }
    })]);
  }
  render() {
    var _this$conditionStyles;
    const h = arguments[0];
    if (!((_this$conditionStyles = this.conditionStyles) !== null && _this$conditionStyles !== void 0 && _this$conditionStyles.length)) return;
    return h("div", {
      "class": styles.conditionStyleCard,
      "style": this.showCondStyle || 'padding-bottom: 8px'
    }, [h("div", {
      "class": [styles.flexTitle, styles.condStyleTitle]
    }, [h("div", {
      "class": styles.flexTitle,
      "style": 'gap:4px'
    }, ["\u6761\u4EF6\u6837\u5F0F", h("a-tooltip", [h("template", {
      "slot": "title"
    }, ["\u5F53\u6761\u4EF6\u4E3Atrue\u65F6, \u6837\u5F0F\u751F\u6548"]), h("i", {
      "class": "fa fa-info-circle",
      "attrs": {
        "aria-hidden": "true"
      }
    })])]), h("a-tooltip", [h("template", {
      "slot": "title"
    }, [this.showCondStyle ? '收起' : '展开']), h("span", {
      "class": styles.conditionStyleButton,
      "on": {
        "click": this.toggleShowCondStyle
      }
    }, [h("i", {
      "style": 'font-size:18px',
      "class": `fa fa-angle-${this.showCondStyle ? 'down' : 'up'}`,
      "attrs": {
        "aria-hidden": "true"
      }
    })])])]), this.showCondStyle && this.conditionStyles.map((item, index) => this.getConditionItem(item, index))]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER
})], ConditionStyleList.prototype, "designer", void 0);
__decorate([Prop({
  type: Array,
  default: []
})], ConditionStyleList.prototype, "conditionStyles", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], ConditionStyleList.prototype, "readonly", void 0);
ConditionStyleList = __decorate([Component({
  name: 'ConditionStyleList'
})], ConditionStyleList);
export { ConditionStyleList };
//# sourceMappingURL=ConditionStyleList.js.map
